import React from 'react'
import { connect } from "react-redux"

import ChangePasswordSection from '../components/common/ChangePasswordSection'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import { Form } from 'react-form'

import * as appActionCreators from "../actionCreators/app.js"
import * as authActionCreators from "../actionCreators/auth.js"

class ChangePassword extends React.Component {
  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.  

    let lobbyistId = this.props.match.params.lobbyistId

    // is invoked immediately after a component is mounted. 
    // Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getChangePasswordDetails(lobbyistId))
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false))
      )
  }

  changePassword = changePasswordDetails => {
    this.props.setLoading(true)
      .then(() => this.props.changePassword(changePasswordDetails))
      .then(response => {
        this.props.setAjaxResponse(response)
        this.props.setLoading(false)
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  render() {
    // check if change password details. If not create an empty object to deal with issues that could be caused by annualReturn being undefined
    let changePasswordDetails = this.props.auth.changePasswordDetails || {}
    let validationRules = changePasswordDetails.ValidationRules ? changePasswordDetails.ValidationRules.$values : []
    return (
      <Form values={changePasswordDetails} onSubmit={this.changePassword}>
        {formApi => {
          return (
            <React.Fragment>
              <ChangePasswordSection isAdmin={false} validationRules={validationRules} />
              <Toolbar>
                <div className="p-toolbar-group-left">
                  <Button label="Change Password" icon="pi pi-check" className="p-button-success" onClick={formApi.submitForm} />
                </div>
              </Toolbar>
            </React.Fragment>
          )
        }}
      </Form>
    )
  }
}

const mapStateToProps = ({ auth }) => {
  return { auth }
}

const actionCreators = {
  ...appActionCreators,
  ...authActionCreators
}

export default connect(mapStateToProps, actionCreators)(ChangePassword);


// WEBPACK FOOTER //
// ./src/container/ChangePassword.js